import API from "./API";

export const getAllCouponApi = async (payload) => {
  try {
    const response = await API.get(`/get/coupons`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSingleCouponApi = async (payload) => {
  try {
    const response = await API.get(`/get/coupon?id=${payload}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const generateCouponApi = async (payload) => {
  try {
    const response = await API.post(`/generate/coupon`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCouponApi = async (payload) => {
  try {
    const response = await API.put(`/edit/coupon`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteCouponApi = async (payload) => {
  try {
    const response = await API.delete(`/delete/coupon?id=${payload}`);
    return response;
  } catch (error) {
    throw error;
  }
};
